import {Inject, Injectable} from '@angular/core';
import {DataPersistence, withCorrelationIdOf} from '@kion/ngrx-helper';
import * as AuthsActions from './auths.actions';
import {map} from 'rxjs/operators';
import {AUTHS_FEATURE_KEY, AuthsPartialState} from './auths.reducer';
import {Actions, createEffect} from '@ngrx/effects';
import {ActionCache} from '../../../../../helper/ngrx-helper/src/lib/action-cache';
import {of} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {CmsConfig} from '../../../../../../lmh/cms/src/lib/config/cms.config';
import {DOCUMENT} from '@angular/common';
import {CookieKeys, MsalService} from '@kion/core';
import {AuthConnectors} from "./auth.connectors";

const noDeletableCookies = [
   CookieKeys.COOKIE_CONSENT,
   CookieKeys.MARKETING,
   CookieKeys.LANGUAGE,
   CookieKeys.SET_IDP_LANGUAGE,
   CookieKeys.BRUTTOP_RICES
];

@Injectable()
export class AuthsEffects {
  clientAuth$ = createEffect(() =>
    this.dataPersistence.fetch(
      AuthsActions.clientAuth,
      {
        run: (action: ReturnType<typeof AuthsActions.clientAuth>, state: AuthsPartialState) => {
          const authClient = this.backend.authenticateClient().pipe(
            map(
              auth => withCorrelationIdOf(
                action,
                AuthsActions.clientAuthSuccess({auth: auth})
              )
            )
          );
          return this.actionCache.withCache(
            action,
            () => authClient,
            (success) => of(withCorrelationIdOf(success, AuthsActions.clientAuthSuccess({auth: state[AUTHS_FEATURE_KEY].entities[0]})))
          )
        },
        onError: (action: ReturnType<typeof AuthsActions.clientAuth>, error) => {
          return withCorrelationIdOf(
            action,
            AuthsActions.clientAuthError({error: error})
          );
        }
      }
    )
  );
  userAuth$ = createEffect(() =>
    this.dataPersistence.fetch(
      AuthsActions.userAuth,
      {
        run: (action: ReturnType<typeof AuthsActions.userAuth>) => {
          return this.backend.tokenAuthentication(
            action.userName,
            action.idToken,
            action.accessToken,
            action.idp,
            action.oid
          ).pipe(
            map(auth => {
              return withCorrelationIdOf(
                action,
                AuthsActions.userAuthSuccess({auth: auth})
              )
            })
          )
        },
        onError: (action: ReturnType<typeof AuthsActions.userAuth>, error) => {
          return withCorrelationIdOf(
            action,
            AuthsActions.userAuthError({error: error})
          )
        }
      }
    )
  );
  userAuthGlobal$ = createEffect(() =>
    this.dataPersistence.fetch(
      AuthsActions.userAuthGlobal,
      {
        run: (action: ReturnType<typeof AuthsActions.userAuthGlobal>) => {
          return this.backend.tokenAuthenticationGlobal(
            action.userName,
            action.idToken,
            action.accessToken,
            action.idp,
            action.oid,
			action.unitNumber,
			action.hash,
			action.isGSMi,
			action.GSMiSite,
			action.dematicPunchOutKey,
			action.dematicPunchOutSid
          ).pipe(
            map(auth => {
              return withCorrelationIdOf(
                action,
                AuthsActions.userAuthSuccess({auth: auth})
              )
            })
          )
        },
        onError: (action: ReturnType<typeof AuthsActions.userAuthGlobal>, error) => {
          return withCorrelationIdOf(
            action,
            AuthsActions.userAuthError({error: error})
          )
        }
      }
    )
  );
  checkWhoAmI$ = createEffect(() =>
    this.dataPersistence.fetch(
      AuthsActions.checkWhoAmI,
      {
        run: (action: ReturnType<typeof AuthsActions.checkWhoAmI>) => {
          return this.backend.checkWhoAmI(action.accessToken).pipe(
            map(
              (response) => {
                return withCorrelationIdOf(
                  action,
                  AuthsActions.checkWhoAmISuccess({check: response})
                )
              }
            )
          )
        },
        onError: (action: ReturnType<typeof AuthsActions.checkWhoAmI>, error) => {
          return withCorrelationIdOf(
            action,
            AuthsActions.checkWhoAmIError({error: error})
          );
        }
      }
    )
  );
  refreshUserToken$ = createEffect(() =>
    this.dataPersistence.fetch(
      AuthsActions.refreshUserToken,
      {
        run: (action: ReturnType<typeof AuthsActions.refreshUserToken>) => {
          return this.backend.refreshToken(action.token).pipe(
            map(
              (response) => {
                return withCorrelationIdOf(
                  action,
                  AuthsActions.refreshUserTokenSuccess({auth: response})
                )
              }
            )
          )
        },
        onError: (action: ReturnType<typeof AuthsActions.refreshUserToken>, error) => {
          return withCorrelationIdOf(
            action,
            AuthsActions.refreshUserTokenError({error: error})
          );
        }
      }
    )
  );
  deleteUserToken$ = createEffect(() =>
    this.dataPersistence.fetch(
      AuthsActions.deleteUserToken,
      {
        run: (
          action: ReturnType<typeof AuthsActions.deleteUserToken>
        ) => {
          this.document.defaultView.localStorage.removeItem("auth");
          return withCorrelationIdOf(
            action,
            AuthsActions.deleteUserTokenSuccess()
          )
        },
        onError: (
          action: ReturnType<typeof AuthsActions.deleteUserToken>,
        ) => {
          return withCorrelationIdOf(
            action,
            AuthsActions.deleteUserTokenError()
          )
        }
      }
    )
  );
  clearAuth$ = createEffect(() =>
    this.dataPersistence.fetch(
      AuthsActions.clearAuth,
      {
        run: (
          action: ReturnType<typeof AuthsActions.clearAuth>
        ) => {
          this.document.defaultView.localStorage.clear();
          Object.keys(this.cookieService.getAll()).forEach(key => {
             if ((Object.values(noDeletableCookies) as string[]).includes(key)) {
              this.cookieService.delete(key, "/");
              this.cookieService.delete(key, this.cmsConfig.basePath);
            }
          });
          //this.cookieService.set('_isLogin', 'true', 200, '/', null, true, "Strict");
		  let dematic = this.cmsConfig.project == 'Dematic';
  		  
  		  if (dematic) {
			const valSameSite = 'None';
		  	this.cookieService.set('_isLogin', 'true', { secure: true, expires: 200, path: '/', sameSite: valSameSite});
		  } else {
			this.cookieService.set('_isLogin', 'true', 200, '/', null, true, "Strict");
		  }
          return withCorrelationIdOf(
            action,
            AuthsActions.clearAuthSuccess()
          )
        },
        onError: (
          action: ReturnType<typeof AuthsActions.clearAuth>,
        ) => {
          return withCorrelationIdOf(
            action,
            AuthsActions.clearAuthError()
          )
        }
      }
    )
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<AuthsPartialState>,
    private backend: AuthConnectors,
    private actionCache: ActionCache,
    private cookieService: CookieService,
    private cmsConfig: CmsConfig,
    private msalService: MsalService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  private getMsalToken(): any {
    const account = this.msalService.getAccount();
    if (account) {
      const sensibleData = Object.entries(this.document.defaultView.localStorage);
      const accountData = sensibleData.find(data =>
        data.find(entry => {
            try {
              return JSON.parse(entry) && JSON.parse(entry).homeAccountIdentifier === account.homeAccountId
            } catch (e) {
              return false;
            }
          }
        ));
      if (accountData) {
        return JSON.parse(accountData[1]);
      }
      return null;
    }
    return null;
  }
}

